import { useEffect, useRef } from "react";
import { useRecordStage } from "@/hooks/use-tasks";
import type { V2StageId } from "../stage-vocabulary";

/**
 * Keeps on the draft the stage the attorney has it open at, so the client's
 * page reopens it there. One write per move to another stage: the stage last
 * sent is remembered, so an effect run again on the same stage, as StrictMode
 * does on mount, sends nothing.
 *
 * A failed write is let pass: it only means the next open lands on the stage
 * before, which is not worth an error in front of the attorney.
 */
export function useRecordLastStage(
  taskId: string | undefined,
  stage: V2StageId | undefined,
): void {
  const { mutate } = useRecordStage(taskId ?? "");
  const sentRef = useRef<string | null>(null);
  useEffect(() => {
    if (taskId === undefined || stage === undefined) return;
    const key = `${taskId}/${stage}`;
    if (sentRef.current === key) return;
    sentRef.current = key;
    mutate(stage);
  }, [mutate, taskId, stage]);
}
